import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 py-20 px-4">
            <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12">
                {/* Header */}
                <div className="text-center mb-12">
                    <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#0a1f44] to-[#1e3a5f] rounded-full mb-6">
                        <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    </div>
                    <h1 className="text-4xl md:text-5xl font-bold text-[#0a1f44] mb-4">
                        Conditions d'Utilisation
                    </h1>
                    <p className="text-gray-600">Dernière mise à jour : 2 septembre 2025</p>
                </div>

                {/* Content */}
                <div className="prose prose-lg max-w-none">
                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            1. Acceptation des Conditions
                        </h2>
                        <p className="text-gray-700 leading-relaxed">
                            En accédant et en utilisant le site web de <strong>WebAura</strong>, vous acceptez d'être lié par ces 
                            conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre site.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            2. Services Proposés
                        </h2>
                        <p className="text-gray-700 leading-relaxed mb-4">
                            WebAura propose les services suivants :
                        </p>
                        <ul className="list-disc pl-6 space-y-2 text-gray-700">
                            <li>Conception et développement de sites web vitrines</li>
                            <li>Création de boutiques e-commerce</li>
                            <li>Développement de blogs professionnels</li>
                            <li>Solutions web sur mesure</li>
                            <li>Hébergement et maintenance de sites web</li>
                            <li>Optimisation SEO et référencement</li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            3. Commande et Paiement
                        </h2>
                        <div className="space-y-4 text-gray-700">
                            <p className="leading-relaxed">
                                <strong>3.1. Processus de commande :</strong> Toute commande est confirmée par email après réception 
                                de votre demande via notre formulaire de contact ou WhatsApp.
                            </p>
                            <p className="leading-relaxed">
                                <strong>3.2. Devis :</strong> Un devis détaillé vous sera envoyé dans les 24-48h suivant votre demande. 
                                Le devis est valable 30 jours.
                            </p>
                            <p className="leading-relaxed">
                                <strong>3.3. Paiement :</strong> Les modalités de paiement sont définies dans le devis. En général :
                            </p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>Acompte de 50% à la validation du devis</li>
                                <li>Solde de 50% à la livraison du projet</li>
                            </ul>
                            <p className="leading-relaxed">
                                <strong>3.4. Moyens de paiement :</strong> Wave, Orange Money, virement bancaire, espèces.
                            </p>
                        </div>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            4. Délais de Livraison
                        </h2>
                        <p className="text-gray-700 leading-relaxed mb-4">
                            Les délais de livraison sont indicatifs et mentionnés dans le devis :
                        </p>
                        <ul className="list-disc pl-6 space-y-2 text-gray-700">
                            <li>Site vitrine : 1-2 semaines</li>
                            <li>E-commerce : 3-4 semaines</li>
                            <li>Blog professionnel : 2 semaines</li>
                            <li>Solutions sur mesure : selon le projet</li>
                        </ul>
                        <p className="text-gray-700 leading-relaxed mt-4">
                            Les délais peuvent être prolongés en cas de retard dans la fourniture des contenus ou de modifications 
                            importantes demandées en cours de projet.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            5. Propriété Intellectuelle
                        </h2>
                        <div className="space-y-4 text-gray-700">
                            <p className="leading-relaxed">
                                <strong>5.1. Droits du client :</strong> À la livraison finale et après paiement intégral, le client 
                                obtient les droits d'utilisation du site web et de son contenu.
                            </p>
                            <p className="leading-relaxed">
                                <strong>5.2. Droits WebAura :</strong> WebAura conserve le droit de présenter le projet dans son 
                                portfolio et ses supports marketing, sauf accord contraire écrit.
                            </p>
                            <p className="leading-relaxed">
                                <strong>5.3. Contenus fournis :</strong> Le client garantit détenir les droits sur tous les contenus 
                                (textes, images, logos) fournis pour le projet.
                            </p>
                        </div>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            6. Garanties et Support
                        </h2>
                        <div className="space-y-4 text-gray-700">
                            <p className="leading-relaxed">
                                <strong>6.1. Garantie technique :</strong> WebAura garantit le bon fonctionnement du site pendant 
                                la période de support mentionnée dans le devis.
                            </p>
                            <p className="leading-relaxed">
                                <strong>6.2. Support technique :</strong> Le support est inclus selon les termes du contrat 
                                (généralement 3-12 mois selon l'offre).
                            </p>
                            <p className="leading-relaxed">
                                <strong>6.3. Mises à jour :</strong> Les mises à jour de contenu par le client sont incluses 
                                pendant la période spécifiée dans le contrat.
                            </p>
                        </div>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            7. Modifications et Révisions
                        </h2>
                        <p className="text-gray-700 leading-relaxed">
                            Le client a droit à un nombre de révisions défini dans le devis (généralement 2-3 révisions majeures). 
                            Les modifications supplémentaires peuvent entraîner des frais additionnels qui seront communiqués au préalable.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            8. Annulation et Remboursement
                        </h2>
                        <div className="space-y-4 text-gray-700">
                            <p className="leading-relaxed">
                                <strong>8.1. Annulation par le client :</strong> En cas d'annulation, l'acompte versé reste acquis 
                                à WebAura pour couvrir les frais engagés.
                            </p>
                            <p className="leading-relaxed">
                                <strong>8.2. Annulation par WebAura :</strong> Si WebAura ne peut honorer son engagement, l'intégralité 
                                des sommes versées sera remboursée.
                            </p>
                            <p className="leading-relaxed">
                                <strong>8.3. Suspension :</strong> Le projet peut être suspendu en cas de non-paiement ou de 
                                non-fourniture des éléments nécessaires par le client.
                            </p>
                        </div>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            9. Responsabilités
                        </h2>
                        <div className="space-y-4 text-gray-700">
                            <p className="leading-relaxed">
                                <strong>9.1. Responsabilité WebAura :</strong> WebAura s'engage à fournir un service de qualité 
                                mais ne peut être tenu responsable des pertes indirectes ou du manque à gagner.
                            </p>
                            <p className="leading-relaxed">
                                <strong>9.2. Responsabilité du client :</strong> Le client est responsable du contenu publié sur 
                                son site et doit respecter les lois en vigueur.
                            </p>
                            <p className="leading-relaxed">
                                <strong>9.3. Hébergement :</strong> En cas d'hébergement tiers, WebAura ne peut être tenu responsable 
                                des interruptions de service liées à l'hébergeur.
                            </p>
                        </div>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            10. Confidentialité
                        </h2>
                        <p className="text-gray-700 leading-relaxed">
                            WebAura s'engage à respecter la confidentialité des informations fournies par le client. 
                            Pour plus de détails, consultez notre <Link to="/privacy-policy" className="text-amber-600 hover:text-amber-700 font-semibold">Politique de Confidentialité</Link>.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            11. Modifications des Conditions
                        </h2>
                        <p className="text-gray-700 leading-relaxed">
                            WebAura se réserve le droit de modifier ces conditions d'utilisation à tout moment. 
                            Les modifications prendront effet dès leur publication sur le site. Nous vous encourageons à consulter 
                            régulièrement cette page.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            12. Droit Applicable et Juridiction
                        </h2>
                        <p className="text-gray-700 leading-relaxed">
                            Ces conditions sont régies par le droit sénégalais. Tout litige sera soumis à la juridiction 
                            des tribunaux de Dakar, Sénégal.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            13. Contact
                        </h2>
                        <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-6 rounded-xl border-2 border-amber-200">
                            <p className="text-gray-700 leading-relaxed mb-4">
                                Pour toute question concernant ces conditions d'utilisation :
                            </p>
                            <div className="space-y-2 text-gray-700">
                                <p><strong>Email :</strong> <a href="mailto:contact@webaura.dev" className="text-amber-600 hover:text-amber-700">contact@webaura.dev</a></p>
                                <p><strong>WhatsApp :</strong> <a href="https://wa.me/221779317865" className="text-amber-600 hover:text-amber-700">+221 77 931 78 65</a></p>
                                <p><strong>Téléphone :</strong> <a href="tel:+221779317865" className="text-amber-600 hover:text-amber-700">+221 77 931 78 65</a></p>
                                <p><strong>Adresse :</strong> Dakar, Sénégal</p>
                            </div>
                        </div>
                    </section>
                </div>

                {/* Back Button */}
                <div className="mt-12 text-center">
                    <Link 
                        to="/" 
                        className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0a1f44] to-[#1e3a5f] text-white px-8 py-4 rounded-full font-semibold hover:from-[#1e3a5f] hover:to-[#2c5282] transform hover:scale-105 transition-all duration-300 shadow-lg"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        Retour à l'accueil
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
